/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Checkout/OrderConfirmation',[
    'global/all'
], function (Roc) {
    'use strict';

    var viewModel;

    function init(model) {
        //Customization: copy order level items customFields to recipient level items
        _.forEach(model.recipients,
            function (recipient) {
                _.forEach(recipient.items, function (item) {
                    var orderItem = _.find(model.items,
                        function (oItem) {
                            return oItem.id === item.id;
                        });
                    if (orderItem) {
                        item.customFields = orderItem.customFields;
                    }
                })
            });
        //End customization
        Roc.UI.template('orderConfirmation-Tmp', model).then(function (renderedTemplate) {
            $('#orderConfirmationDetails').html(renderedTemplate);
        });

        viewModel = model;

        mixpanel.track('Requested Quote', {
            "dollars": model.total,
            "lineCount": model.items.length,
            "time": new Date(),
            'products': getQuoteProducts(model.items)
        });

        Roc.EventManager.notify(Roc.Events.cart.ORDER_CONFIRM, viewModel, true);
        };

    function getQuoteProducts(items) {
        var products = "";
        _.forEach(items, function (item) {
            products = products + " " + item.sku;
        });
       
        return products;
    }

    var OrderConfirmation = {
        init: init,
        viewModel: viewModel
    };

    Roc.Logger.debug('OrderConfirmation.js Loaded:', OrderConfirmation);

    return OrderConfirmation;
});

